export default __webpack_public_path__ + "static/media/563.63ac7462.png";